export const menuData = [
    {title: "Portfolio", link: "/portfolio"},
    {title: "Photography", link: "/photography"},
    {title: "Contact", link: "/contact"},

]